import { render, staticRenderFns } from "./projectDetails.html?vue&type=template&id=a866a246&"
import script from "./projectDetails.js?vue&type=script&lang=js&"
export * from "./projectDetails.js?vue&type=script&lang=js&"
import style0 from "./projectDetails.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports